export const AJAX_USERS_SELECT_OPTIONS_MAP = {
  projectId: 'projectId',
  groupId: 'groupId',
  showCurrentUser: 'currentUser',
  authorId: 'authorId',
  skipUsers: 'skipUsers',
};

export const AJAX_USERS_SELECT_PARAMS_MAP = {
  project_id: 'projectId',
  group_id: 'groupId',
  skip_ldap: 'skipLdap',
  todo_filter: 'todoFilter',
  todo_state_filter: 'todoStateFilter',
  current_user: 'showCurrentUser',
  author_id: 'authorId',
  skip_users: 'skipUsers',
};
